import { useRecoilValue } from 'recoil'
import { configSelector, ConfigType, ConfigTypeGeneric } from '../atoms/configAtom'

export function useConfig<T extends ConfigTypeGeneric = {}>(): ConfigType<T> {
  const config = useRecoilValue(configSelector)
  return config as ConfigType<T>
}
